import React, { useEffect, useContext, useState, useMemo, useCallback, useRef } from 'react';
import Client from '../../api/client';
import UserContext from '../../business/referential/UserContext';
import DataTable from '../../components/generic/DataTable';
import { ThreeCircles } from 'react-loader-spinner';

function HistoricWebsite(props) {
    const [userData, setUserData] = useState(null);
    const ctx = useContext(UserContext);
    const fetchIdRef = useRef(0);
    const [loading, setLoading] = useState(false);
    const [ready, setReady] = useState(false);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [forceRefresh, setForceRefresh] = useState(true);
    const [pageCount, setPageCount] = useState(0)
    const [pageId, setPageId] = useState(14);

    const getContent = (key) => {
        if (userData) {
            if (userData.dataContent[pageId][key]) {
                return userData.dataContent[pageId][key].contentTxt;
            }
        }
        return '';
    }

    const columns = useMemo(
        () => {
            if (userData && userData.dataContent) {
                return [
                    {
                        Header: getContent("TitleHistoWebsite"),
                        columns: [
                            {
                                Header: getContent("COL1"),
                                accessor: 'date',
                                classNameHeader: "col-5 col-lg-4 col-xl-2",
                                className: "col-5 col-lg-4 col-xl-2"
                            },
                            {
                                Header: getContent("COL2"),
                                accessor: 'websiteName',
                                classNameHeader: "col-5 col-lg-4 col-xl-4",
                                className: "col-5 col-lg-4 col-xl-4 text-break"
                            },
                            {
                                Header: getContent("COL3"),
                                Cell: ({ row: { original } }) => {
                                    return <>
                                        <a href={original.receipt}>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.6315 17.2632H8.21045" stroke="#0759E4" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M16.6315 13.0527H8.21045" stroke="#0759E4" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M10.3157 8.84229H9.26308H8.21045" fill="#0759E4" />
                                                <path d="M10.3157 8.84229H9.26308H8.21045" stroke="#0759E4" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
                                                <path d="M14.6472 1.95965L14.6471 1.95958C14.5265 1.85495 14.3681 1.8 14.2079 1.8H4.43488C4.11257 1.8 3.8 2.0315 3.8 2.37594V21.6241C3.8 21.9685 4.11257 22.2 4.43488 22.2H20.3948C20.7171 22.2 21.0297 21.9685 21.0297 21.6241V7.86559C21.0733 7.6689 21.0008 7.46925 20.8463 7.33531L15.9893 3.12484L15.9892 3.12474L14.6472 1.95965ZM15.1157 3.96169L18.8182 7.17594H14.8545V3.73517L15.1156 3.96159L15.1157 3.96169ZM5.06975 2.95188H13.5847V7.75188C13.5847 8.09633 13.8973 8.32782 14.2196 8.32782H19.7599V21.0481H5.06975V2.95188Z" fill="#0759E4" stroke="#0759E4" strokeWidth="0.4" />
                                            </svg>
                                        </a>
                                    </>
                                },
                                classNameHeader: "col-3 col-lg-2 text-nowrap",
                                className: "col-3 col-lg-2"
                            },
                            {
                                Header: getContent("COL4"),
                                Cell: ({ row: { original } }) => {
                                    return <>
                                        <a href={original.file}>
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16.8565 15.0481C16.6124 15.12 16.254 15.1282 15.8697 15.0725C15.4573 15.0128 15.0366 14.8869 14.6232 14.7015C15.3605 14.5944 15.9325 14.6274 16.4217 14.8005C16.5376 14.8415 16.728 14.951 16.8565 15.0481ZM12.7427 14.373C12.7127 14.3811 12.6832 14.3888 12.6538 14.3969C12.4554 14.4508 12.2623 14.5034 12.0763 14.5502L11.8255 14.6137C11.3209 14.7412 10.805 14.8714 10.2955 15.0265C10.4891 14.5603 10.669 14.089 10.8452 13.6282C10.9756 13.2871 11.1088 12.9386 11.2465 12.5947C11.3164 12.7099 11.3893 12.8252 11.4652 12.9407C11.8109 13.4663 12.2455 13.9522 12.7427 14.373ZM11.4592 9.11631C11.492 9.69149 11.3677 10.2449 11.1852 10.7757C10.9606 10.1193 10.856 9.39443 11.1368 8.80924C11.2088 8.65927 11.2678 8.57906 11.3061 8.5372C11.3652 8.62832 11.4429 8.83208 11.4592 9.11631ZM8.82507 16.4027C8.69886 16.6281 8.57003 16.8391 8.43798 17.0383C8.11932 17.5178 7.59818 18.031 7.33046 18.031C7.30411 18.031 7.27223 18.0268 7.22565 17.9777C7.19566 17.9463 7.19086 17.9238 7.19231 17.8931C7.20134 17.7168 7.43527 17.4029 7.77415 17.1119C8.08175 16.8478 8.42941 16.6131 8.82507 16.4027ZM17.709 15.0731C17.6681 14.486 16.678 14.1093 16.6683 14.1058C16.2856 13.9704 15.8698 13.9045 15.3973 13.9045C14.8915 13.9045 14.3461 13.9776 13.6458 14.141C13.0226 13.6999 12.4843 13.1479 12.082 12.5366C11.9045 12.2666 11.7448 11.997 11.6056 11.7337C11.9454 10.9227 12.2513 10.0506 12.1957 9.07393C12.1509 8.29079 11.7972 7.76475 11.3161 7.76475C10.9861 7.76475 10.7019 8.00874 10.4709 8.49064C10.0587 9.34934 10.1671 10.4481 10.7927 11.7592C10.5674 12.2876 10.3581 12.8353 10.1554 13.3656C9.90327 14.0249 9.64343 14.7051 9.35066 15.3522C8.5295 15.6766 7.8549 16.07 7.2927 16.5529C6.9244 16.8686 6.4804 17.3514 6.45506 17.8554C6.44268 18.0927 6.52421 18.3104 6.68987 18.4848C6.86587 18.6699 7.08698 18.7674 7.33011 18.7677C8.13309 18.7677 8.90592 17.6663 9.05253 17.4454C9.3476 17.0015 9.62375 16.5062 9.89438 15.9349C10.5759 15.6891 11.3023 15.5055 12.0063 15.3281L12.2585 15.2642C12.448 15.2161 12.645 15.1629 12.847 15.1077C13.0609 15.05 13.2808 14.9901 13.5044 14.9333C14.2273 15.3922 15.0047 15.6916 15.7629 15.8014C16.4015 15.8941 16.9686 15.8404 17.3525 15.6405C17.6979 15.4609 17.717 15.1838 17.709 15.0731ZM19.2641 20.1214C19.2641 21.1966 18.3148 21.2629 18.1233 21.2651H5.87567C4.80251 21.2651 4.73789 20.3109 4.73584 20.1214L4.73569 3.87821C4.73569 2.80195 5.68673 2.7367 5.87552 2.73454H14.1491L14.1534 2.7389V5.96198C14.1534 6.60881 14.5452 7.83343 16.0287 7.83343H19.2365L19.264 7.8609L19.2641 20.1214ZM18.5037 7.09879H16.0293C14.9564 7.09879 14.8915 6.14984 14.89 5.96208V3.47654L18.5037 7.09879ZM20 20.1214V7.55787L14.89 2.43551L14.5 2.5L15.2201 2.76643L14.4552 2H5.8757C5.22689 2 4 2.39267 4 3.87856V20.1217C4 20.7713 4.39216 22 5.8757 22H18.1244C18.7731 21.9999 20 21.6071 20 20.1214Z" fill="#0759E4" stroke="#0759E4" strokeWidth="0.7" />
                                            </svg>
                                        </a>
                                    </>
                                },
                                classNameHeader: "col-2 col-xl-1",
                                className: "col-2 col-xl-1"
                            },
                            {
                                Header: getContent("COL5"),
                                Cell: ({ row: { original } }) => {
                                    return <>
                                        <a href={original.link}>
                                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11.1108 1.73253L11.1109 1.73245C13.0875 -0.245317 16.2912 -0.243172 18.2728 1.73301C20.2447 3.70857 20.2486 6.91284 18.27 8.89032L18.2699 8.89037L14.5145 12.6458C14.2084 12.9515 13.869 13.2062 13.5098 13.4188L13.5095 13.4189C12.3279 14.12 10.9235 14.2987 9.62714 13.9532L9.6271 13.9532C8.7947 13.7315 8.00769 13.2994 7.35671 12.6472L7.35632 12.6469C6.9576 12.2492 6.64771 11.797 6.4102 11.3148L7.92854 9.79643C7.92857 9.79639 7.92861 9.79636 7.92865 9.79632C7.97994 9.74531 8.03716 9.69905 8.09999 9.65651C8.2061 10.192 8.4628 10.7043 8.8815 11.122C9.64456 11.8855 10.7191 12.1226 11.6853 11.862C12.1591 11.7356 12.6132 11.497 12.9894 11.1209C12.9894 11.1209 12.9894 11.1209 12.9894 11.1209L14.3735 9.73762L14.3736 9.73753L16.7442 7.36614L16.7443 7.366C17.8778 6.23029 17.8785 4.39671 16.7453 3.25831L16.7445 3.25753C15.6086 2.12644 13.77 2.12161 12.6357 3.25808L11.0041 4.88968C10.9117 4.85678 10.8119 4.82222 10.7131 4.79524L10.7118 4.79489C9.88616 4.5743 9.02855 4.53017 8.19469 4.64801L11.1108 1.73253Z" fill="#0759E4" stroke="white" strokeWidth="0.5" />
                                                <path d="M7.33884 16.7152L7.33918 16.7148L8.98748 15.0654C9.93547 15.3705 10.9402 15.4481 11.9172 15.2948L8.92187 18.2967C8.92182 18.2968 8.92176 18.2968 8.92171 18.2969C6.92646 20.2904 3.69658 20.2903 1.70265 18.2967L1.70263 18.2967C-0.290427 16.3044 -0.289452 13.0725 1.70391 11.078L5.4599 7.32197C5.45993 7.32194 5.45996 7.32191 5.45999 7.32188C5.7696 7.01343 6.11142 6.75743 6.47283 6.54414L6.47309 6.54398C7.66587 5.83769 9.08027 5.65694 10.3888 6.00597L10.3888 6.00598C11.2269 6.22936 12.0199 6.66545 12.679 7.32214C13.0862 7.7305 13.4017 8.19416 13.6412 8.6881L12.0993 10.2288L12.0991 10.2291C12.0291 10.2992 11.9531 10.3607 11.8724 10.4148C11.7756 9.86482 11.5198 9.33719 11.094 8.90814L11.093 8.90716C10.3384 8.15691 9.27985 7.92312 8.32716 8.1784L8.38109 8.37966L8.32738 8.17834C7.86117 8.30272 7.41589 8.53715 7.04458 8.90586L7.04407 8.90637L3.28696 12.6627L3.28649 12.6631C2.17261 13.7839 2.1702 15.5923 3.28792 16.7134L3.28832 16.7138C4.40734 17.8303 6.21945 17.8302 7.33884 16.7152Z" fill="#0759E4" stroke="white" strokeWidth="0.416726" />
                                            </svg>
                                        </a>
                                    </>
                                },
                                classNameHeader: "col-2 col-xl-1",
                                className: "col-2 col-xl-1"
                            },
                            {
                                Header: getContent("COL6"),
                                Cell: ({ row: { original } }) => {
                                    return <>
                                        {original.status && <a href={original.link} title="Certified" >
                                            <img src="/assets/img/validstatus.png" style={{ maxWidth: "42px" }} alt="Certified" />
                                        </a>}
                                    </>
                                },
                                classNameHeader: "col-3 col-lg-2",
                                className: "col-3 col-lg-2"
                            }
                        ],
                    },
                ];
            }
            else {
                return [];
            }
        },
        [userData]
    );


    const fetchData = useCallback(({ pageSize, pageIndex }) => {
        //d-flex g-0

        if (userData) {
            const getData = async () => {
                // Set the loading state
                setLoading(true)

                let datas = [];
                if (pageCount === 0 && pageSize > 0) {
                    await Client.getCopyrightWebHistoric(userData.userObject.id, pageIndex + 1, pageSize, search, forceRefresh).then((r) => {
                        //console.log(r)
                        setPageCount(Math.ceil(r.data.totalRows / pageSize));
                        datas = r.data;
                    });
                }

                if (datas.length === 0) {
                    await Client.getCopyrightWebHistoric(userData.userObject.id, pageIndex + 1, pageSize, search, forceRefresh).then((r) => {
                        datas = r.data;
                    });
                }

                // Give this fetch an ID
                const fetchId = ++fetchIdRef.current

                //HERE FETCHING DATAS
                if (fetchId === fetchIdRef.current) {
                    console.log(datas.data);

                    const startRow = pageSize * pageIndex
                    const endRow = startRow + pageSize
                    setData(datas.data)
                    setLoading(false)
                }
                setForceRefresh(false);
            }
            getData();
        }
    }, [userData]);

    useEffect(() => {

        if (data && data.length > 0) {
            setReady(true);
        }
    }, [data]);

    useEffect(() => {

        const process = async () => {

            Promise.resolve(ctx).then(value => {
                setUserData(value);
            });
        }

        process();

    }, []);

    return (<>
        <div className="dashboard-container">
            <h3 className="mb-4 mb-md-5">
                {getContent("TitleHistoWebsite")}
            </h3>
            <div className="table-container mb-5">
                {columns && data &&
                    <DataTable
                        columns={columns}
                        data={data}
                        fetchData={fetchData}
                        loading={(!ready)}
                        pageCount={pageCount}
                        isPaginable={true}
                        classNameDiv="table-responsive-xl"
                        getRowProps={{ className: "d-flex g-0" }}
                        getHeadProps={{ className: "d-flex g-0" }}
                    />}
            </div>
            <ThreeCircles
                height="100"
                width="100"
                color="#3898ff"
                wrapperStyle={{ flex: 1, marginTop: 240, justifyContent: 'center', alignItems: 'center' }}
                wrapperClass=""
                visible={(ready === false)}
                ariaLabel="three-circles-rotating"
                outerCircleColor=""
                innerCircleColor=""
                middleCircleColor=""
            />
            <a href="/dashboard" className="arrow-back"></a>
        </div>
    </>
    );
}

export default HistoricWebsite;